import {
  appendAction, computeNextActionName, getActionName, isActionOfType, setActionName,
} from '../actions';
import type { WFPolicyOperationResult, WorkflowPolicy } from './types';
import type { Action, DataRoute, Threshold } from 'flow/store/engine/types';
import { ActionType } from 'flow/store/engine/constants';
import { appendThreshold } from '../thresholds';
import { appendDataRoute } from '../dataRoutes';
import buildDependencies from 'flow/store/engine/dependencies';

export function addActionToPolicy(
  policy: WorkflowPolicy,
  input: {
    action: Action;
    relatedDataRoutes: DataRoute[];
    relatedThresholds: Threshold[];
  },
): WFPolicyOperationResult {
  const {
    action, relatedThresholds, relatedDataRoutes,
  } = input;

  let actionToAdd = structuredClone(action);
  const nextActionName = computeNextActionName(actionToAdd, policy.data.actions);
  if (getActionName(actionToAdd) !== nextActionName) {
    actionToAdd = setActionName(actionToAdd, nextActionName);
  }

  const nextActions = appendAction(
    actionToAdd,
    policy.data.actions,
  );

  const thresholdsToAdd = relatedThresholds?.filter(threshold => {
    if (threshold.actionId !== actionToAdd.publicId) {
      return false;
    }
    if (threshold.right.actionId) {
      const rightAction = nextActions[threshold.right.actionId];
      if (
        rightAction
          && isActionOfType(rightAction,
            [ActionType.MATRIX_MODEL, ActionType.IMPORTED_MATRIX_MODEL],
          )
      ) {
        return false;
      }
    }
    return true;
  });

  const nextThresholds = appendThreshold(
    thresholdsToAdd,
    policy.data.thresholds,
  );


  const dataRoutesToAdd = relatedDataRoutes?.filter(dataRoute => {
    if (dataRoute.targetId !== actionToAdd.publicId) {
      return false;
    }
    return true;
  });

  const nextDataRoutes = appendDataRoute(
    dataRoutesToAdd,
    policy.data.dataRoutes,
  );


  return {
    ok: true,
    issues: null,
    policy: {
      ...policy,
      data: {
        ...policy.data,
        actions: nextActions,
        thresholds: nextThresholds,
        dataRoutes: nextDataRoutes,
      },
      dependencies: buildDependencies({
        actions: nextActions,
        thresholds: nextThresholds,
        dataRoutes: nextDataRoutes,
      }),
    },
  };
}
